/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from "vue";

require("./bootstrap");

// window.Vue = require('vue')
import store from "./store";
import Lang from "lang.js";
import "img-comparison-slider";

const app_locale = window.applocale;
const fallback_locale = window.fallback_locale;
const messages = window.messages;
const currency = window.currency;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/* global Vue */

Vue.prototype.$trans = new Lang({
    messages,
    locale: app_locale,
    fallback: fallback_locale,
});

Vue.filter("formatSize", function (size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + " GB";
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + " MB";
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + " KB";
    }
    return size.toString() + " B";
});

Vue.filter("toCurrency", function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
    });
    return formatter.format(value);
});

Vue.filter("toInt", function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat("de-DE", {
        style: "decimal",
        minimumFractionDigits: 0,
    });
    return formatter.format(value);
});

Vue.filter("toFloat", function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat("de-DE", {
        style: "decimal",
        minimumFractionDigits: 2,
    });
    return formatter.format(value);
});

// FORMS
Vue.component("upload-file-form", () =>
    import("./components/forms/FileUpload.vue")
);
Vue.component("product-form", () =>
    import("./components/forms/ProductForm.vue")
);
Vue.component("number-input", () =>
    import("./components/forms/NumberInput.vue")
);
Vue.component("admin-new-ad-form", () =>
    import("./components/forms/AdminAdForm.vue")
);
Vue.component("admin-campaign-form", () =>
    import("./components/forms/CampaignForm.vue")
);
Vue.component("admin-download-form", () =>
    import("./components/forms/AdminDownloadForm.vue")
);
Vue.component("admin-photo-form", () =>
    import("./components/forms/AdminPhotoForm.vue")
);
Vue.component("admin-event-form", () =>
    import("./components/forms/AdminEventForm.vue")
);
Vue.component("admin-user-form", () =>
    import("./components/forms/AdminUserForm.vue")
);
Vue.component("admin-news-form", () =>
    import("./components/forms/AdminNewsForm.vue")
);
Vue.component("admin-coupon-form", () =>
    import("./components/forms/AdminCouponForm.vue")
);
Vue.component("admin-tutorial-form", () =>
    import("./components/forms/AdminTutorialForm.vue")
);
Vue.component("admin-glass-form", () =>
    import("./components/forms/AdminGlassForm.vue")
);
Vue.component("admin-glasses-list", () =>
    import("./components/admin/glasses/List.vue")
);

// SHOP
Vue.component("product-functions", () =>
    import("./components/shop/ProductFunctions.vue")
);
Vue.component("product-add2cart", () =>
    import("./components/shop/AddToCart.vue")
);
Vue.component("shop-cart", () => import("./components/shop/Cart.vue"));
Vue.component("shop-checkout", () => import("./components/shop/Checkout.vue"));
Vue.component("shop-customize", () =>
    import("./components/shop/Customize.vue")
);

Vue.component("shop-glasses-list", () =>
    import("./components/shop/GlassesList.vue")
);

// CREATE
Vue.component("admin-ad-functions", () =>
    import("./components/create/AdminAdFunctions.vue")
);
Vue.component("user-add-ad", () =>
    import("./components/create/UserAddFunction.vue")
);
Vue.component("user-ad-functions", () =>
    import("./components/create/UserAdFunctions.vue")
);
Vue.component("user-edit-form", () =>
    import("./components/create/UserEditForm.vue")
);
// Vue.component('image-compare', () => import('./components/create/ImageCompare.vue'))

// ELEMENTS
Vue.component("dynamic-badge", () =>
    import("./components/elements/DynamicBadge.vue")
);
Vue.component("flash-message", () =>
    import("./components/elements/FlashMessage.vue")
);
Vue.component("table-filter", () =>
    import("./components/elements/TableFilter.vue")
);

// CROPPER
Vue.component("ocm-cropper", () =>
    import("./components/elements/ImageCropper.vue")
);

// CAMPAIGNS
Vue.component("admin-campaign-functions", () =>
    import("./components/campaign/AdminCampaignFunctions.vue")
);

// Modals
Vue.component("confirm-modal", () =>
    import("./components/modals/ConfirmModal.vue")
);
Vue.component("common-modal", () =>
    import("./components/modals/CommonModal.vue")
);
Vue.component("mediathek-modal", () =>
    import("./components/modals/MediathekModal.vue")
);
Vue.component("delete-campaign-modal", () =>
    import("./components/modals/DeleteCampaignModal.vue")
);
Vue.component("admin-delete-object-modal", () =>
    import("./components/modals/AdminDeleteModal.vue")
);

// Calendar
Vue.component("calendar-entry", () =>
    import("./components/calendar/CalendarEntry.vue")
);
Vue.component("admin-event-functions", () =>
    import("./components/calendar/AdminEventFunctions.vue")
);

// Contest
Vue.component("contest-user-wizzard", () =>
    import("./components/contest/UserWizzard.vue")
);

// Photo
Vue.component("select-photo", () =>
    import("./components/photo/SelectPhoto.vue")
);
Vue.component("download-photos", () =>
    import("./components/photo/DownloadPhotos.vue")
);

// Admin Stats
Vue.component("admin-stats", () => import("./components/stats/AdminStats.vue"));

// Admin Analytics
Vue.component("analytics-chart", () =>
    import("./components/analytics/AnalyticsChart.vue")
);
Vue.component("analytics-actions", () =>
    import("./components/analytics/ActionsTable.vue")
);
Vue.component("analytics-filterable", () =>
    import("./components/analytics/AnalyticsFilterable.vue")
);
Vue.component("analytics-customers", () =>
    import("./components/analytics/AnalyticsCustomers.vue")
);

// ADMIN
Vue.component("admin-campaign-list", () =>
    import("./components/admin/campaign/List.vue")
);
Vue.component("admin-photos-list", () =>
    import("./components/admin/photos/List.vue")
);
Vue.component("admin-downloads-list", () =>
    import("./components/admin/downloads/List.vue")
);
Vue.component("admin-ads-list", () =>
    import("./components/admin/ads/List.vue")
);
Vue.component("admin-products-list", () =>
    import("./components/admin/products/List.vue")
);

Vue.config.ignoredElements = [/img-comparison-slider/];

// eslint-disable-next-line no-unused-vars
const app = new Vue({
    el: "#app",
    store,
});

$("div.alert").not(".alert-important").delay(5000).fadeOut(350);

$(document).ready(function () {
    $(".lightbox-enabled").Chocolat({
        fullScreen: false,
    });
});

/* $('.navbar-toggler').hover(function() {
    $('#mainnav').collapse('show')
}, function() {
    $('#mainnav').collapse('hide')
}) */

$("#mainnav").on("shown.bs.collapse", function () {
    const container = $(this);
    $(document).on("mouseover", function (e) {
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.collapse("hide");
        }
    });
});

$(".tutorialvideo").one("click", function (event) {
    $.ajax({
        url: "/track",
        data: {
            model: "Tutorial",
            modelid: $(this).attr("data-name"),
        },
        success: function () {},
    });
});

$("body").on("mouseover", ".tutorialvideo", function (e) {
    $(this).attr("controls", "");
});

$("body").on("mouseout", ".tutorialvideo", function (e) {
    $(this).removeAttr("controls");
});
